import React from 'react';
import './NoPermission.css';

export { NoPermission };

function NoPermission() {
    return (
        <div className="no-permission-container">
            <h1>No Permission</h1>
            <p>You do not have permission to view this page.</p>
        </div>
    );
}